import React from 'react';
import { motion } from 'framer-motion';
export function Difference() {
  const problems = ['Impulsos automáticos', 'Disparadores invisibles', 'Insomnio y ansiedad sostenida', 'Pensamientos tipo "me lo merezco"'];
  const questions = [{
    num: 1,
    text: '¿Qué hago hoy?',
    accent: false
  }, {
    num: 2,
    text: '¿Qué hago cuando se dispara?',
    accent: false
  }, {
    num: 3,
    text: '¿Qué hago si recaigo?',
    accent: true
  }, {
    num: 4,
    text: '¿Cómo retomo mañana?',
    accent: false
  }];
  return <section className="py-24 md:py-32 px-6 bg-[#2D2A26] text-[#FAF8F5]" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-serif text-[#F5F3F0]" data-id="element-33">
            La diferencia de esta guía vs lo que ya probaste
          </h2>

          <div className="space-y-6 text-lg text-[#D4D0C8] leading-relaxed" data-id="element-34">
            <p data-id="element-35">
              Muchos contenidos hablan de "no recaer" como si fuera solo
              "decidirlo".
            </p>
            <p data-id="element-36">
              Pero cuando estás con ansiedad en abstinencia, decidir no siempre
              alcanza.
            </p>
            <p className="text-white font-medium text-xl" data-id="element-37">
              Esta guía trabaja lo que realmente te hace caer:
            </p>

            <ul className="space-y-3 pl-1" data-id="element-38">
              {problems.map((problem, index) => <li key={index} className="flex items-center gap-3 text-[#D4915D]" data-id="element-39">
                  <span className="w-2 h-2 rounded-full bg-[#D4915D]" data-id="element-40" />
                  {problem}
                </li>)}
            </ul>
          </div>

          <div className="bg-[#FAF8F5]/5 p-8 md:p-10 rounded-2xl border border-[#FAF8F5]/10" data-id="element-41">
            <p className="text-xl font-serif mb-8 text-[#F5F3F0]" data-id="element-42">
              Y lo convierte en acciones simples:
            </p>
            <ul className="space-y-5" data-id="element-43">
              {questions.map(q => <li key={q.num} className="flex items-center gap-4" data-id="element-44">
                  <span className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${q.accent ? 'bg-[#C4956A]' : 'bg-[#7C8B6F]'}`} data-id="element-45">
                    {q.num}
                  </span>
                  <span className="text-lg text-[#E5E0D8]" data-id="element-46">{q.text}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}